import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/access-token';

export class AccessTokenService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async createAccessToken(
    params: types.CreateAccessTokenParameters,
  ): Promise<types.CreateAccessTokenResponse> {
    const { data } = await this.axios.post<types.CreateAccessTokenResponse>(
      'accesstokens',
      params.body,
    );
    return data;
  }
  async decipherAccessToken(
    params: types.DecipherAccessTokenParameters,
  ): Promise<types.DecipherAccessTokenResponse> {
    const { data } = await this.axios.get<types.DecipherAccessTokenResponse>(
      `accesstokens/${params.path.token}`,
    );
    return data;
  }
}
